import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Download, RefreshCw, GraduationCap, IndianRupee } from 'lucide-react';
import WorkshopRecordingsAdmin from './WorkshopRecordingsAdmin';

const WorkshopSalesTab = ({ API_URL }) => {
  const [data, setData] = useState({ total: 0, total_paid: 0, revenue: 0, items: [] });
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/workshop/registrations`);
      if (res.ok) setData(await res.json());
    } catch (e) { /* ignore */ }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const exportCsv = () => window.open(`${API_URL}/api/admin/workshop/registrations/export`, '_blank');
  const rupee = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

  return (
    <div className="space-y-6" data-testid="workshop-sales-tab">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <GraduationCap className="w-5 h-5 text-amber-600" />
          <h2 className="text-xl font-bold text-gray-800">Workshop Sales</h2>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={fetchData} data-testid="workshop-refresh-btn">
            <RefreshCw className="w-4 h-4 mr-1" /> Refresh
          </Button>
          <Button size="sm" className="bg-amber-600 hover:bg-amber-700 text-white" onClick={exportCsv} data-testid="workshop-export-btn">
            <Download className="w-4 h-4 mr-1" /> Export CSV
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <p className="text-sm text-gray-500">Paid Seats</p>
          <p className="text-2xl font-bold text-gray-800" data-testid="workshop-paid-count">{data.total_paid}</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <p className="text-sm text-gray-500">Revenue</p>
          <p className="text-2xl font-bold text-emerald-600 flex items-center">
            <IndianRupee className="w-5 h-5" />{Number(data.revenue || 0).toLocaleString('en-IN')}
          </p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <p className="text-sm text-gray-500">Total (incl. pending)</p>
          <p className="text-2xl font-bold text-gray-800">{data.total}</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-left">
              <tr>
                <th className="px-4 py-3 font-semibold">Date</th>
                <th className="px-4 py-3 font-semibold">Name</th>
                <th className="px-4 py-3 font-semibold">Phone</th>
                <th className="px-4 py-3 font-semibold">Email</th>
                <th className="px-4 py-3 font-semibold">Amount</th>
                <th className="px-4 py-3 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading ? (
                <tr><td colSpan={6} className="px-4 py-8 text-center text-gray-400">Loading…</td></tr>
              ) : data.items.length === 0 ? (
                <tr><td colSpan={6} className="px-4 py-8 text-center text-gray-400">No workshop registrations yet.</td></tr>
              ) : (
                data.items.map((r, i) => (
                  <tr key={r.id || i} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                      {(r.paid_at || r.created_at) ? new Date(r.paid_at || r.created_at).toLocaleString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3 font-medium text-gray-800">{r.name}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{r.phone}</td>
                    <td className="px-4 py-3 text-gray-600">{r.email}</td>
                    <td className="px-4 py-3 text-gray-700">{rupee(r.amount)}{r.coupon_code ? <span className="text-xs text-green-600"> · {r.coupon_code}</span> : null}</td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${r.status === 'paid' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-500'}`}>
                        {r.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <WorkshopRecordingsAdmin API_URL={API_URL} />
    </div>
  );
};

export default WorkshopSalesTab;
